import type { ReactElement } from 'react';
import { StatusDot } from '../StatusDot';

interface MCPStatusIndicatorProps {
  runningCount: number;
}

/**
 * Component for displaying MCP server running status with tooltip
 */
export function MCPStatusIndicator({
  runningCount,
}: MCPStatusIndicatorProps): ReactElement {
  const isActive = runningCount > 0;
  const tooltip = isActive
    ? `${runningCount} instance${runningCount !== 1 ? 's' : ''} currently running`
    : 'No instances currently running';

  return (
    <StatusDot
      isActive={isActive}
      activeLabel="Active"
      inactiveLabel="Inactive"
      tooltip={tooltip}
      align="start"
    />
  );
}
